import styled from 'styled-components'
import {ReactComponent as LogoSVG} from './logo.svg'
import {Marginals} from '../../styles'

/*export const Logo = styled(LogoSVG)`
  height: auto;
  max-width: 48rem;
  width: 100%;
`
*/

export const Name = styled.h1.attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  font-size: 8vmin;
  font-weight: 700;
  padding: 0;
  line-height: 1;
  padding: 0;
  margin: 0;
`
export const BreedInfo = styled.div`
  /* display: flex;

  justify-content: center;
  padding: 0;
  margin: 0; */
`
export const LogoTwo = styled.h1.attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  font-weight: 500;
  margin: 0;
`
export const LogoThree = styled.h1.attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  font-weight: 200;
  margin: 0;
`

export const Header = styled.header`
  position: fixed;
  z-index: 1;

  right: 0;

  width: 40vw;

  justify-content: center;

  font-size: 3vmin;
  text-transform: uppercase;
  text-align: right;

  overflow-wrap: break-word;
`
